<template>
    <div class="x-modal-holder" :style="modalHolderStyle">
        <div class="modal"
             tabindex="-1"
             role="dialog"
             :class="modalClass"
             :style="modalStyle"
             @click="hideFromModal"
             v-el:modal>
            <div class="modal-dialog" role="document" v-bind:style="{'width': width + 'px'}">
                <div class="modal-content">
                    <div class="modal-header" v-if="(title || $hasSlot('header')) && !hideHeader">
                        <button class="new-close" type="button" @click="hide()" v-tooltip :vtitle="closeLabel" v-if="!hideClose">
                            &times;
                        </button>
                        <h4 class="modal-title">
                            <slot name="header">{{ title }}</slot>
                        </h4>
                        <div class="clearfix"></div>
                    </div>
                    <div class="modal-body" :class="getBodyClass()" v-el:modal-body>
                        <slot></slot>
                    </div>
                    <div class="modal-footer" v-if="$hasSlot('footer') && !hideFooter">
                        <slot name="footer"></slot>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
.modal-content{
    max-height: 90vh;
    overflow-y: auto;
}
</style>
<style scoped>
    .modal {
    }

    @keyframes coolModalTransition {
        from {
            opacity: 0;
            transform: translateY(-100px);
        }
        to {
            opacity: 1;
            transform: translateY(0px);
        }
    }

    @keyframes coolModalHolderTransition {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }

    .x-modal-holder {
        animation: coolModalHolderTransition .3s cubic-bezier(0, 0, 0, 0.50);
        background-color: rgba(0, 0, 0, .5);
        position: fixed;
        bottom: 0;
        top: 0;
        left: 0;
        right: 0;
    }

    .ui-modal__visible {
        display: block;
        animation: coolModalTransition .3s cubic-bezier(0, 0, 0, 0.50);
    }
</style>
<script type="text/babel">
    let openedModals = [];
    const { guid } = require('sci/helpers')

    const $ = require('jquery')
    /**
     * A ideia é criar um modal reusável,
     * Como existem limitações no Bootstrap, onde, por exemplo, não podemos colocar um botão que
     * chama um modal dentro de um btn-group, o elemento é renderizado fora do escopo pra evitar
     * isso.
     */
    export default{
        name: 'ui-modal',
        props: {
            text: {
                type: String,
                default: 'Carregando...'
            },
            onlyBlock: {
                default: false
            },
            title: {
                default: null
            },
            destroy: {
                default: true,
                type: Boolean
            },
            width: {
                default: 600,
                type: Number
            },
            noPaddingBody: {
                type: Boolean,
                default: false
            },
            onHidden: {
                type: Function,
                default: null
            },
            backdropClickable: {
                type: Boolean,
                default: true
            },
            hideFooter: {
                type: Boolean,
                default: false
            },
            hideHeader: {
                type: Boolean,
                default: false
            },
            hideClose: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                modalId: guid(),
                state: false
            }
        },
        ready () {
            this.$$root = this.$root
            this.$newEl = this.$appendTo(document.body).$el
        },
        destroyed () {
            if (this.state) {
                document.body.classList.remove('x-modal-open');
                openedModals = openedModals.filter(_ => _ !== this.modalId)
            }
            document.body.removeChild(this.$newEl)
        },
        methods: {
            backdropClicked () {
                if (this.backdropClickable) {
                    this.hide()
                }
            },
            hideFromModal (evt) {
                if (evt.target === this.$els.modal) {
                    this.backdropClicked()
                }
            },
            onEsc (evt) {
                this.hide()
            },
            show () {
                openedModals = [...openedModals, this.modalId]
                document.body.classList.add('x-modal-open');
                if (this.backdropClickable) {
                    this.$$root && this.$$root.onEsc(this.onEsc)
                }

                return new Promise((resolve, reject) => {
                    this.$emit('show')

                    this.$nextTick(() => {
                        resolve()

                        this.$emit('shown')

                        this.focus()
                    })

                    this.state = true
                })
            },
            hide () {
                openedModals = openedModals.filter(_ => _ !== this.modalId)
                document.body.classList.remove('x-modal-open');
                if (this.backdropClickable) {
                    this.$$root && this.$$root.offEsc(this.onEsc)
                }

                return new Promise((resolve, reject) => {
                    this.$emit('hide')

                    this.$nextTick(() => {
                        resolve()

                        this.$emit('hidden')

                        if (this.onHidden) {
                            this.onHidden()
                        }
                    })

                    this.state = false
                })
            },
            getBodyClass () {
                const classes = []

                if (this.noPaddingBody) {
                    classes.push('no-padding-body')
                }

                return classes
            },
            focus () {
                const el = this.$els.modalBody.querySelector('[autofocus]')

                if (el) {
                    el.focus()
                }
            }
        },
        computed: {
            modalClass () {
                return {
                    'ui-modal__visible': this.state
                }
            },
            modalHolderStyle () {
                if (this.state) {
                    return {
                        zIndex: 20049 + openedModals.length,
                        display: 'block'
                    }
                }

                return {
                    display: 'none'
                }
            },
            modalStyle () {
                if (this.state) {
                    return {
                        zIndex: 20050 + openedModals.length,
                        display: 'block'
                    }
                }

                return {
                    display: 'none'
                }
            },
            closeLabel () {
                if (this.backdropClickable) {
                    return 'Fechar (ESC)'
                }

                return 'Fechar'
            }
        }
    }
</script>



// WEBPACK FOOTER //
// Modal.vue?21d3c18d